let index = 0;

export const generateID = () => {
  return (index += 1);
};
